import React, { useRef, useState, useEffect } from "react";
import { Button, Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import Header from "../../../../components/headers/Header";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import * as Helper from "../../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/agent/teacheraccount/EditRedux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useForm } from "react-hook-form";

import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import "antd/dist/antd.css";

const uid = UIDs.screens.admin.agent.teacheraccount.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_TEACHER_ACCOUNT_ASYNC]: { done: this._handleSaveTeacherAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        this.props.loadScreenViewAsync({id: "", partnerId: this.props.partnerId});
    }

    render() {
        const { teacherInfo } = this.props.localState;
        return (
            <>
                {!teacherInfo || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                    ? <LoadingIndicator />
                    : <EditForm
                        {...this.props}
                        teacherInfo={teacherInfo}
                        onSave={this._handleSaveInfo}
                        onBack={this._handleBack}
                        isDisabled={this.isActionExecuting(ActionTypes.SAVE_TEACHER_ACCOUNT_ASYNC)}
                    />
                }
            </>
        );
    }

    _handleSaveInfo = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...data, partnerId: this.props.partnerId }
                        this.props.saveTeacherAccountAsync(data);
                    },
                },
                {
                    label: this.props.t("no"),
                },
            ],
        });
    };

    _handleBack = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };

    _handleSaveTeacherAsyncDone = () => {
        const { sendPwd } = this.props.localState;
        NavigationService.navigateToPage(this, `/admin/agent/teacheraccount/code`, {sendPwd});
    };

}

function EditForm(props) {
    const { name, email, nationality, organization  } = props.teacherInfo;
    const { register, handleSubmit, errors, clearError } = useForm();
    const submitRef = useRef();
    const countries = Helper.getCountries();

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <Row>
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{props.t("add")}</h3>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button color="primary" disabled={props.isDisabled} onClick={() => submitRef.current.click()} size="sm">
                                                {props.t("activateNow")}
                                            </Button>
                                            <Button color="default" disabled={props.isDisabled} onClick={() => props.onBack()} size="sm">
                                                {props.t("back")}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("name")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="name"
                                                        defaultValue={name}
                                                        type="text"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            validate: {
                                                                message: value => {
                                                                    if (value.replace(/\s/g, "").length === 0) {
                                                                        return props.t("nameSpace");
                                                                    }
                                                                    if (value.length > 20) {
                                                                        return props.t("invalidLengthH", { name: props.t("name"), max: 20 });
                                                                    }

                                                                    if(Helper.existsSepcialContent(value)){
                                                                        return props.t("invalidContent");
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}
                                                        maxLength={100}
                                                    />
                                                    {errors.name && <span className="text-danger">{errors.name.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("email")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="email"
                                                        defaultValue={email}
                                                        type="email"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                message: props.t("invalidEmailAddress"),
                                                            },
                                                            validate: {
                                                                message: value => {
                                                                    if (value.length > 50) {
                                                                        return props.t("invalidLength", { name: props.t("email"), max: 50 });
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}
                                                        maxLength={100}
                                                    />
                                                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("nationality")}</label>
                                                    <select
                                                        className="form-control-alternative form-control"
                                                        name="nationality"
                                                        defaultValue={nationality}
                                                        ref={register({
                                                            required: props.t("fieldIsRequired")
                                                        })}>
                                                        <option value="">{props.t("selectACountry")}</option>
                                                        {Object.keys(countries).map((key, index) =>{
                                                                if(key!=="TW" && key!=="HK" && key!=="MO"){
                                                                    return <option key={index} selected={nationality===key} value={key}>{countries[key]}</option>
                                                                }
                                                            }
                                                        )}
                                                    </select>
                                                    {errors.nationality && <span className="text-danger">{errors.nationality.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("organization")}</label>
                                                    <input name="organization" type="text" className="form-control-alternative form-control" defaultValue={organization}
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            pattern: {
                                                                value: /[^\s]$/i,
                                                                message: props.t("organizationSpace")
                                                            },
                                                            validate: {
                                                                message: value => {
                                                                    if(Helper.existsSepcialContent(value)){
                                                                        return props.t("invalidContent");
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })} />
                                                    {errors.organization && <span className="text-danger">{errors.organization.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <input ref={submitRef} type="submit" hidden />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </form>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadScreenViewAsync: (vo) => dispatch(Actions.loadScreenViewAsync(vo)),
        saveTeacherAccountAsync: (vo) => dispatch(Actions.saveTeacherAccountAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
